<template>
    <div class="row">
        <div
            class="col-xs-12"
            :class="{ 'col-md-10 col-sm-9': !wide, 'col-sm-6': wide}"
        >
            <label :for="id">{{ label }}</label>
        </div>
        <div
            class="col-xs-12 text-right"
            :class="{ 'col-md-2 col-sm-3': !wide, 'col-sm-6': wide}"
        >
            <input
                v-if="type !== 'textarea'"
                :name="id"
                :id="id"
                :type="type"
                :placeholder="placeholder"
                v-model="localVal"
                v-bind="$attrs"
                class="form-control"
            >
            <textarea
                v-if="type === 'textarea'"
                :name="id"
                :id="id"
                :placeholder="placeholder"
                v-bind="$attrs"
                v-model="localVal"
                :rows="rows"
                class="form-control"
            />
            <error
                :name="id"
                :errors="errors"
            />
        </div>
    </div>
</template>

<script>
import UsesErrors from '../../../mixins/UsesErrors';

export default {
    mixins: [UsesErrors],
    props: {
        value: {
            required: false,
            default: '',
        },
        label: {
            required: true,
            type: String
        },
        id: {
            required: true,
            type: String
        },
        type: {
            required: false,
            type: String,
            default: 'text',
        },
        placeholder: {
            required: false,
            type: String,
            default: 'Type here...',
        },
        wide: {
            default: false,
            type: Boolean,
        },
        rows: {
            default: 2,
            type: Number,
        },
    },
    data() {
        return {
            localVal: null,
        }
    },
    watch: {
        value: {
            handler: function(newValue) {
                this.localVal = newValue;
            },
            immediate: true,
        },
        localVal: {
            handler: function (newValue) {
                if (this.localVal !== this.value) {
                    this.$emit('input', newValue);
                }
            },
            immediate: true,
        }
    },
    mounted() {
        this.localVal = this.value;
    },
    methods: {
        emitInput($event) {
            this.$emit("input", this.localVal);
        }
    },
};
</script>

<style lang="scss" scoped>
.row {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/TextRowComponent.vue